export default __webpack_public_path__ + "static/app-features-6-9eaee8bae6797ee9e3a1e7c90069467c.webp";